"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VideoChatCubby = void 0;
var _react = _interopRequireDefault(require("react"));
var _lodash = require("lodash");
var _utils = require("./utils");
var _VideoChatCubbyContext = require("./VideoChatCubbyContext");
var _ = require("./..");
var _components = require("../../components");
var _utils2 = require("../../utils");
var _components2 = require("./components");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var VideoChatCubbyScreenContent = function VideoChatCubbyScreenContent(_ref) {
  var onScheduleAppointment = _ref.onScheduleAppointment;
  var _useVideoChatCubby = (0, _VideoChatCubbyContext.useVideoChatCubby)(),
    currentScreen = _useVideoChatCubby.currentScreen,
    screens = _useVideoChatCubby.screens,
    onGoToScreen = _useVideoChatCubby.onGoToScreen,
    loadingGetNote = _useVideoChatCubby.loadingGetNote,
    sectionStatuses = _useVideoChatCubby.sectionStatuses,
    readonly = _useVideoChatCubby.readonly;
  if (loadingGetNote) {
    return /*#__PURE__*/_react.default.createElement(_.SpinPlaceholder, null);
  }
  if (currentScreen === _utils.VideoChatCubbyScreen.SectionIndex) {
    return /*#__PURE__*/_react.default.createElement(_components2.SectionIndexScreen, {
      screens: screens,
      onScheduleAppointment: onScheduleAppointment
    });
  }
  return /*#__PURE__*/_react.default.createElement(_components.MonumentTabs, {
    activeKey: currentScreen,
    onChange: function onChange(key) {
      return onGoToScreen(key);
    },
    tabsRowStyles: "pt-[24px] px-[20px] border-0 border-b border-solid border-grey-20 bg-grey-10"
  }, /*#__PURE__*/_react.default.createElement(_components.TabPane, {
    className: "--tag-video-chat-cubby-screen flex-grow h-0 flex flex-col",
    label: _utils.VideoChatCubbyScreenTitles[_utils.VideoChatCubbyScreen.Patient],
    key: _utils.VideoChatCubbyScreen.Patient
  }, /*#__PURE__*/_react.default.createElement(_components2.PatientScreen, null)), /*#__PURE__*/_react.default.createElement(_components.TabPane, {
    className: "--tag-video-chat-cubby-screen flex-grow h-0 flex flex-col",
    label: _utils.VideoChatCubbyScreenTitles[_utils.VideoChatCubbyScreen.Prescriptions],
    key: _utils.VideoChatCubbyScreen.Prescriptions
  }, /*#__PURE__*/_react.default.createElement(_components2.PrescriptionsScreen, null)), /*#__PURE__*/_react.default.createElement(_components.TabPane, {
    className: "--tag-video-chat-cubby-screen flex-grow h-0 flex flex-col",
    label: _utils.VideoChatCubbyScreenTitles[_utils.VideoChatCubbyScreen.Notes],
    key: _utils.VideoChatCubbyScreen.Notes,
    showDot: sectionStatuses[_utils.VideoChatCubbyScreen.Notes] !== _utils.NoteSectionStatus.Complete && !readonly
  }, /*#__PURE__*/_react.default.createElement(_components2.NotesScreen, null)), /*#__PURE__*/_react.default.createElement(_components.TabPane, {
    className: "--tag-video-chat-cubby-screen flex-grow h-0 flex flex-col",
    label: _utils.VideoChatCubbyScreenTitles[_utils.VideoChatCubbyScreen.Billing],
    key: _utils.VideoChatCubbyScreen.Billing,
    showDot: sectionStatuses[_utils.VideoChatCubbyScreen.Billing] !== _utils.NoteSectionStatus.Complete && !readonly
  }, /*#__PURE__*/_react.default.createElement(_components2.BillingScreen, null)));
};
var VideoChatCubby = function VideoChatCubby(_ref2) {
  var _ref2$showAppointment = _ref2.showAppointmentCubby,
    showAppointmentCubby = _ref2$showAppointment === void 0 ? true : _ref2$showAppointment;
  var modal = (0, _utils2.useModalState)();
  var _useVideoChatCubby2 = (0, _VideoChatCubbyContext.useVideoChatCubby)(),
    booking = _useVideoChatCubby2.booking,
    patient = _useVideoChatCubby2.patient,
    onScheduleAppointmentSuccess = _useVideoChatCubby2.onScheduleAppointmentSuccess;
  // Get full profile as it is eventually passed to AppointmentSelector components
  var _useRequest = (0, _utils2.useRequest)((0, _utils2.getClinicianProfileUrl)('me'), {
      ready: showAppointmentCubby
    }),
    _useRequest$data = _useRequest.data,
    clinician = _useRequest$data === void 0 ? {} : _useRequest$data,
    loadingClinician = _useRequest.loading;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "--tag-video-chat-cubby w-full h-full bg-white flex flex-col"
  }, loadingClinician ? /*#__PURE__*/_react.default.createElement(_.SpinPlaceholder, null) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_components2.VideoChatCubbyHeader, null), (0, _lodash.isEmpty)(booking) ? /*#__PURE__*/_react.default.createElement("p", {
    className: "px-[20px] py-[24px]"
  }, "Could not find an appointment to associate with this video call. Please contact support to resolve this issue.") : /*#__PURE__*/_react.default.createElement(VideoChatCubbyScreenContent, {
    onScheduleAppointment: modal.show
  }))), showAppointmentCubby && /*#__PURE__*/_react.default.createElement(_.ManagerAppointmentCubby, {
    patient: patient,
    clinician: clinician,
    visible: modal.visible,
    onCancel: modal.hide,
    onSuccess: function onSuccess() {
      modal.hide();
      onScheduleAppointmentSuccess();
    }
  }));
};
exports.VideoChatCubby = VideoChatCubby;